// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__zFyA5","up":"Rating_up__WP5zB","down":"Rating_down__Tx53X"};